/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DowngradeLoyaltyStatus.vue?vue&type=template&id=7152d712"
import script from "./DowngradeLoyaltyStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./DowngradeLoyaltyStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DowngradeLoyaltyStatus.vue?vue&type=style&index=0&id=7152d712&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports